function requiredIf(message, predicate) {
    return (value, values) => {
        if (predicate(values) && !value) {
            throw new Error(message);
        }
    };
}
export default requiredIf;
